import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import mixpanel from 'mixpanel-browser';
import * as Sentry from '@sentry/react';

import { isEmail, getFilters } from 'utils';
import { exportView } from 'services/Views/thunks';
import { DEFAULT_FILE_FORMAT } from 'constants/reports';
import { FLASH_MESSAGE_TYPES } from 'constants/common';

import EmailsBox from 'components/EmailsBox';
// import FileFormatSelection from 'components/FileFormat';
import FlashMessage from 'components/FlashMessage';

import {
  Container,
  Relative,
  Modal,
  Header,
  Title,
  Close,
  Content,
  Footer,
  CancelButton,
  SaveButton,
} from 'styles/modals';
import { ModalBodyContainer } from './styles';

import { selectUser } from 'services/Authentication/selectors';
import { ANALYTICS_EVENTS } from 'constants/mixpanel.constants';

export const SENTRY_EXPORT_VIEW_NAME = 'Export';

class ExportView extends Component {
  static defaultProps = {
    onExportSuccess: () => undefined,
  };

  state = {
    sendByEmail: true,
    // @ts-expect-error TS(2339): Property 'user' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    emails: [this.props.user.email],
    fileFormat: DEFAULT_FILE_FORMAT,

    flashMessageVisible: false,
    flashMessageType: null,
    flashMessage: null,
  };

  componentDidUpdate = (prevProps) => {
    // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (prevProps.visible !== this.props.visible && document.body) {
      // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
      if (this.props.visible) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  };

  canExport = () => {
    if (!this.state.sendByEmail) {
      return true;
    }

    return isEmail(this.state.emails);
  };

  // Closes the modal
  handleCloseModal = () => {
    // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (this.props.loading) {
      return;
    }

    // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
    this.props.onCloseModal();
  };

  // Changes the export type between email and download
  handleSelectExportType = (type) => () => {
    if (type === 'email') {
      this.setState({ sendByEmail: true });

      return;
    }

    this.setState({ sendByEmail: false });
  };

  // Updates the list of emails
  handleChangeEmails = (emails) => {
    this.setState({ emails });
  };

  // Exports the view
  handleExportView = () => {
    // @ts-expect-error TS(2339): Property 'view' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { view } = this.props;

    if (!view) {
      return;
    }

    mixpanel.track(ANALYTICS_EVENTS.EXPORT, {
      view_id: view.get('id'),
      by_email: this.state.sendByEmail,
    });

    Sentry.startSpan({ name: SENTRY_EXPORT_VIEW_NAME }, async () => {
      await this.props
        // @ts-expect-error TS(2339): Property 'exportView' does not exist on type 'Read... Remove this comment to see the full error message
        .exportView(
          view.get('id'),
          view.get('name'),
          view.get('type'),
          this.state.fileFormat,
          this.state.sendByEmail ? this.state.emails : null,
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          getFilters(view.get('rules'))
        )
        .then(() => {
          this.setState({
            sendByEmail: true,
            // @ts-expect-error TS(2339): Property 'user' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            emails: [this.props.user.email],
            fileFormat: DEFAULT_FILE_FORMAT,
          });

          // @ts-expect-error TS(2339): Property 'onExportSuccess' does not exist on type ... Remove this comment to see the full error message
          this.props.onExportSuccess();

          this.handleCloseModal();
        })
        .catch(() => {
          this.handleOpenFlashMessage(
            // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            this.props.intl.formatMessage({
              id: 'notification.downloadFail',
            }),
            FLASH_MESSAGE_TYPES.error
          );
        });
    });
  };

  //=================================================
  //  Flash message related
  //=================================================

  // Opens the flash message
  handleOpenFlashMessage = (text, type) => {
    this.setState({
      flashMessageVisible: true,
      flashMessageType: type,
      flashMessage: text,
    });
  };

  // Closes the flash message
  handleCloseFlashMessage = () => {
    this.setState({
      flashMessageVisible: false,
      flashMessageType: null,
      flashMessage: null,
    });
  };

  render() {
    // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (!this.props.visible) {
      return null;
    }

    return (
      <Container data-testid="export-view">
        <FlashMessage
          visible={this.state.flashMessageVisible}
          type={this.state.flashMessageType}
          text={this.state.flashMessage}
          onClose={this.handleCloseFlashMessage}
        />

        <Relative>
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <Modal loading={this.props.loading}>
            <Header>
              <Title>
                <FormattedMessage id="components.Modals.ExportView.title" />
              </Title>
              <Close
                onClick={() => {
                  mixpanel.track(ANALYTICS_EVENTS.CLOSE_MODAL);
                  // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
                  this.props.onCloseModal();
                }}
                className="icon-close-light"
                // @ts-expect-error TS(2769): No overload matches this call.
                disabled={this.props.loading}
                padded
              />
            </Header>

            <Content>
              <ModalBodyContainer>
                <FormattedMessage id="components.Modals.ExportView.directive" />
              </ModalBodyContainer>

              <EmailsBox
                visible={this.state.sendByEmail}
                // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
                label={this.props.intl.formatMessage({
                  id: 'components.Modals.ExportView.emailAddresses',
                })}
                emails={this.state.emails}
                onChangeEmails={this.handleChangeEmails}
              />
            </Content>

            <Footer>
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <CancelButton onClick={this.handleCloseModal} disabled={this.props.loading} />
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <SaveButton onClick={this.handleExportView} loading={this.props.loading} disabled={!this.canExport()}>
                <FormattedMessage id="components.Modals.ExportView.export" />
              </SaveButton>
            </Footer>
          </Modal>
        </Relative>
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      exportView,
    },
    dispatch
  );

const mapStateToProps = createStructuredSelector({
  user: selectUser(),
});

// @ts-expect-error TS(2345): Argument of type 'ConnectedComponent<FC<WithIntlPr... Remove this comment to see the full error message
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ExportView)));
